import { Card, CardHeader, Divider, Image, CardBody, CardFooter, Link } from '@nextui-org/react';
import React from 'react';

/**
 * RenderDocs Component
 * Displays filtered documents in a responsive grid layout
 * Renders document cards with metadata, descriptions, and source links
 * @param {Object} props - Component props
 * @param {Array<Object>} props.filteredDocuments - Array of filtered document objects
 * @returns {JSX.Element} Document grid display component
 */
const RenderDocs = ({ filteredDocuments }) => {
  return (
    <div>
      {/* Document Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-2 pt-12 px-4">
        {filteredDocuments.map((document, index) => {
          // Extract document data with fallbacks
          const doc = document.raw_document || document;
          const source = doc.metadata?.source || doc.source;
          const description = doc.document_description || doc.content?.substring(0, 80) + '...';

          return (
            <Card
              key={`doc-${index}`}
              className="max-w-[400px] border border-divider shadow-none transition-opacity duration-800 ease-in-out opacity-1 animate-fadeIn"
            >
              {/* Document Header */}
              <CardHeader className="flex gap-3">
                <Image
                  alt="Document Avatar"
                  width={40}
                  height={40}
                  radius="sm"
                />
                <div className="flex flex-col">
                  <p className="text-md">{doc?.document_title}</p>
                  <p className="text-small text-default-500">{doc?.document_url}</p>
                </div>
              </CardHeader>
              
              <Divider />
              
              {/* Document Description */}
              <CardBody className="max-h-[100px] overflow-hidden">
                <p className="text-xs">
                  {description
                    ? description.substring(0, 80) + (description.length > 80 ? '...' : '')
                    : ''}
                </p>
              </CardBody>
              
              <Divider />
              
              {/* Document Footer with Source Link */}
              <CardFooter>
                <Link isExternal showAnchorIcon href={doc?.document_url}>
                  Visit source
                </Link>
              </CardFooter>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default RenderDocs;
